import React from 'react';

import { TextInput, TextInputProps } from '@mantine/core';

import inputClasses from './kiloInput.module.css';

interface KiloInputProps extends TextInputProps {
  variantStyle?: 'default' | 'outlinedWithLabel' | 'kiosk'; // extend as needed
  label: string;
}

const variantClassMap = {
  default: {},
  outlinedWithLabel: {
    input: inputClasses.outlined,
    label: inputClasses.outlinedLabel,
  },
  kiosk: {
    input: inputClasses.kiosk,
    label: inputClasses.kioskLabel,
  },
};

const KiloInput = ({ variantStyle = 'default', label, ...props }: KiloInputProps): JSX.Element => {
  const variantClasses = variantClassMap[variantStyle];

  return (
    <TextInput
      label={label}
      classNames={{
        ...variantClasses,
      }}
      {...props}
    />
  );
};

export default KiloInput;
